import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { LazyQuestions } from '@confluence/questions';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const QuestionRoute: {
	({ params: { spaceKey, questionId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey, questionId } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				questionId: string;
			};
			pageState: {
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
		};
	};
} = ({ params: { spaceKey, questionId } }: RouteMatch): React.JSX.Element => {
	return <LazyQuestions spaceKey={spaceKey} questionId={questionId} />;
};

QuestionRoute.NAVIGATION_PARAMS = ({ params: { spaceKey, questionId } }: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'questionScreen',
			questionId,
		},
		pageState: { spaceKey },
	},

	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
	},
});
